<template>
  <div class="po-create-page main-content">
    <form
      v-if="!initLoading"
      action=""
      @submit.prevent="submitPurchaseOrderData((redirectPOAttachment = false))"
    >
      <div class="page-header">
        <h3 v-if="$route.name === 'purchase-orders.edit'" class="page-title">
          {{ $t("pos.edit_po") }}
        </h3>
        <h3 v-else class="page-title">{{ $t("pos.new_po") }}</h3>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/anchor/dashboard">{{
              $t("general.home")
            }}</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link slot="item-title" to="/anchor/purchase-orders">{{
              $tc("pos.po", 2)
            }}</router-link>
          </li>
          <li
            v-if="$route.name === 'purchase-orders.edit'"
            class="breadcrumb-item"
          >
            {{ $t("pos.edit_po") }}
          </li>
          <li v-else class="breadcrumb-item">{{ $t("pos.new_po") }}</li>
        </ol>
        <div class="page-actions row">
          <a
            v-if="$route.name === 'purchase-orders.edit'"
            :href="`/purchaseOrders/pdf/${newPurchaseOrder.unique_hash}`"
            target="_blank"
            class="mr-3 base-button btn btn-outline-primary default-size invoice-action-btn"
            outline
            color="theme"
          >
            {{ $t("general.view_pdf") }}
          </a>
          <div class="col-xs-2 mr-4">
            <base-button
              :outline="true"
              icon="file"
              size="large"
              color="theme"
              right-icon
              @click="POAttchements"
            >
              {{ $tc("pos.attachments", 2) }}
            </base-button>
          </div>
          <base-button
            :loading="isLoading"
            :disabled="isLoading"
            icon="save"
            class="invoice-action-btn"
            color="theme"
            type="submit"
          >
            {{ $t("pos.save_po") }}
          </base-button>
        </div>
      </div>
      <div class="row po-input-group">
        <div class="col-md-5 po-customer-container">
          <div v-if="selectedSupplier" class="show-customer">
            <div class="row px-2 mt-1">
              <div v-if="selectedSupplier" class="col col-12">
                <div class="row address-menu">
                  <label class="col-sm-4 px-2 title">{{
                    $t("general.supplier")
                  }}</label>
                  <div class="col-sm p-0 px-2 content">
                    <label v-if="selectedSupplier.name">
                      {{ selectedSupplier.name }}
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="selectedSupplier.billing_address" class="col col-6">
                <div class="row address-menu">
                  <label class="col-sm-4 px-2 title">{{
                    $t("general.bill_to")
                  }}</label>
                  <div class="col-sm p-0 px-2 content">
                    <label v-if="selectedSupplier.billing_address.name">
                      {{ selectedSupplier.billing_address.name }}
                    </label>
                    <label
                      v-if="selectedSupplier.billing_address.address_street_1"
                    >
                      {{ selectedSupplier.billing_address.address_street_1 }}
                    </label>
                    <label
                      v-if="selectedSupplier.billing_address.address_street_2"
                    >
                      {{ selectedSupplier.billing_address.address_street_2 }}
                    </label>
                    <label
                      v-if="
                        selectedSupplier.billing_address.city &&
                          selectedSupplier.billing_address.state
                      "
                    >
                      {{ selectedSupplier.billing_address.city }},
                      {{ selectedSupplier.billing_address.state }}
                      {{ selectedSupplier.billing_address.zip }}
                    </label>
                    <label v-if="selectedSupplier.billing_address.country">
                      {{ selectedSupplier.billing_address.country.name }}
                    </label>
                    <label v-if="selectedSupplier.billing_address.phone">
                      {{ selectedSupplier.billing_address.phone }}
                    </label>
                  </div>
                </div>
              </div>
              <div v-if="selectedSupplier.shipping_address" class="col col-6">
                <div class="row address-menu">
                  <label class="col-sm-4 px-2 title">{{
                    $t("general.ship_to")
                  }}</label>
                  <div class="col-sm p-0 px-2 content">
                    <label v-if="selectedSupplier.shipping_address.name">
                      {{ selectedSupplier.shipping_address.name }}
                    </label>
                    <label
                      v-if="selectedSupplier.shipping_address.address_street_1"
                    >
                      {{ selectedSupplier.shipping_address.address_street_1 }}
                    </label>
                    <label
                      v-if="selectedSupplier.shipping_address.address_street_2"
                    >
                      {{ selectedSupplier.shipping_address.address_street_2 }}
                    </label>
                    <label
                      v-if="
                        selectedSupplier.shipping_address.city &&
                          selectedSupplier.shipping_address
                      "
                    >
                      {{ selectedSupplier.shipping_address.city }},
                      {{ selectedSupplier.shipping_address.state }}
                      {{ selectedSupplier.shipping_address.zip }}
                    </label>
                    <label
                      v-if="selectedSupplier.shipping_address.country"
                      class="country"
                    >
                      {{ selectedSupplier.shipping_address.country.name }}
                    </label>
                    <label
                      v-if="selectedSupplier.shipping_address.phone"
                      class="phone"
                    >
                      {{ selectedSupplier.shipping_address.phone }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="customer-content mb-1">
              <label class="email">{{ selectedSupplier.name }}</label>
              <label class="action" @click="removeSupplier">{{
                $t("general.deselect")
              }}</label>
            </div>
          </div>

          <base-popup
            v-else
            :class="[
              'add-customer',
              { 'customer-required': $v.selectedSupplier.$error }
            ]"
          >
            <div slot="activator" class="add-customer-action">
              <font-awesome-icon icon="user" class="customer-icon" />
              <div>
                <label
                  >{{ $t("suppliers.new_supplier") }}
                  <span class="text-danger"> * </span></label
                >
                <p
                  v-if="
                    $v.selectedSupplier.$error && !$v.selectedSupplier.required
                  "
                  class="text-danger"
                >
                  {{ $t("pos.errors.required") }}
                </p>
              </div>
            </div>
            <supplier-select-popup type="purchaseOrder" />
          </base-popup>
        </div>
        <div class="col po-input">
          <div class="row mb-3">
            <div class="col collapse-input">
              <label
                >{{ $t("reports.pos.po_date")
                }}<span class="text-danger"> * </span></label
              >
              <base-date-picker
                v-model="newPurchaseOrder.purchase_order_date"
                :calendar-button="true"
                calendar-button-icon="calendar"
                @change="$v.newPurchaseOrder.purchase_order_date.$touch()"
              />
              <span
                v-if="
                  $v.newPurchaseOrder.purchase_order_date.$error &&
                    !$v.newPurchaseOrder.purchase_order_date.required
                "
                class="text-danger"
              >
                {{ $t("validation.required") }}
              </span>
            </div>
            <div class="col collapse-input">
              <label
                >{{ $t("pos.due_date")
                }}<span class="text-danger"> * </span></label
              >
              <base-date-picker
                v-model="newPurchaseOrder.expiry_date"
                :invalid="$v.newPurchaseOrder.expiry_date.$error"
                :calendar-button="true"
                calendar-button-icon="calendar"
                @change="$v.newPurchaseOrder.expiry_date.$touch()"
              />
              <span
                v-if="
                  $v.newPurchaseOrder.expiry_date.$error &&
                    !$v.newPurchaseOrder.expiry_date.required
                "
                class="text-danger mt-1"
              >
                {{ $t("validation.required") }}</span
              >
            </div>
          </div>
          <div class="row mb-3">
            <div class="col collapse-input">
              <label
                >{{ $t("pos.supplier_bank_name")
                }}<span class="text-danger"> * </span></label
              >
              <base-input
                v-model="newPurchaseOrder.supplier_bank_name"
                :invalid="$v.newPurchaseOrder.supplier_bank_name.$error"
                @input="$v.newPurchaseOrder.supplier_bank_name.$touch()"
              />
              <div
                v-if="
                  $v.newPurchaseOrder.supplier_bank_name.$error &&
                    !$v.newPurchaseOrder.supplier_bank_name.required
                "
                class="text-danger"
              >
                {{ $tc("validation.required") }}
              </div>
            </div>
            <div class="col collapse-input">
              <label
                >{{ $t("pos.buyer_bank_name")
                }}<span class="text-danger"> * </span></label
              >
              <base-input
                v-model="newPurchaseOrder.buyer_bank_name"
                :invalid="$v.newPurchaseOrder.buyer_bank_name.$error"
                @input="$v.newPurchaseOrder.buyer_bank_name.$touch()"
              />
              <div
                v-if="
                  $v.newPurchaseOrder.buyer_bank_name.$error &&
                    !$v.newPurchaseOrder.buyer_bank_name.required
                "
                class="text-danger"
              >
                {{ $tc("validation.required") }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col collapse-input">
              <label>{{ $t("pos.ref_num") }}</label>
              <base-input
                v-model="newPurchaseOrder.reference_number"
                :invalid="$v.newPurchaseOrder.reference_number.$error"
                icon="hashtag"
                @input="$v.newPurchaseOrder.reference_number.$touch()"
              />
              <div
                v-if="$v.newPurchaseOrder.reference_number.$error"
                class="text-danger"
              >
                {{ $tc("validation.ref_number_maxlength") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <table class="item-table">
        <colgroup>
          <col style="width: 40%;" />
          <col style="width: 10%;" />
          <col style="width: 15%;" />
          <col style="width: 15%;" />
        </colgroup>
        <thead class="item-table-header">
          <tr>
            <th class="text-left row">
              <span class="column-heading item-heading col-md-6">
                {{ $tc("items.item", 2) }}
              </span>
              <span class="column-heading item-heading col-md-6">
                {{ $tc("items.part_number", 2) }}
              </span>
            </th>
            <th class="text-right">
              <span class="column-heading">
                {{ $t("pos.item.quantity") }}
              </span>
            </th>
            <th class="text-left">
              <span class="column-heading">
                {{ $t("pos.item.price") }}
              </span>
            </th>
            <th class="text-right">
              <span class="column-heading amount-heading">
                {{ $t("pos.item.amount") }}
              </span>
            </th>
          </tr>
        </thead>
        <draggable
          v-model="newPurchaseOrder.items"
          class="item-body"
          tag="tbody"
          handle=".handle"
        >
          <PO-item
            v-for="(item, index) in newPurchaseOrder.items"
            :key="item.id"
            :index="index"
            :item-data="item"
            :currency="currency"
            :order-items="newPurchaseOrder.items"
            :tax-per-item="taxPerItem"
            :discount-per-item="discountPerItem"
            @remove="removeItem"
            @update="updateItem"
            @itemValidate="checkItemsData"
          />
        </draggable>
      </table>
      <div class="add-item-action" @click="addItem">
        <font-awesome-icon icon="shopping-basket" class="mr-2" />
        {{ $t("pos.add_item") }}
      </div>

      <div class="po-foot">
        <div>
          <label>{{ $t("pos.notes") }}</label>
          <base-text-area
            v-model="newPurchaseOrder.notes"
            rows="3"
            cols="50"
            @input="$v.newPurchaseOrder.notes.$touch()"
          />
          <div v-if="$v.newPurchaseOrder.notes.$error">
            <span
              v-if="!$v.newPurchaseOrder.notes.maxLength"
              class="text-danger"
              >{{ $t("validation.notes_maxlength") }}</span
            >
          </div>
          <label class="mt-3 mb-1 d-block"
            >{{ $t("pos.po_template") }}
            <span class="text-danger"> * </span></label
          >
          <base-button
            type="button"
            class="btn-template"
            icon="pencil-alt"
            right-icon
            @click="openTemplateModal"
          >
            <span class="mr-4">
              {{ $t("pos.po_template") }} {{ getTemplateId }}
            </span>
          </base-button>
        </div>

        <div class="po-total">
          <div class="section">
            <label class="po-label">{{ $t("pos.sub_total") }}</label>
            <label class="po-amount">
              <div v-html="$utils.formatMoney(subtotal, currency)" />
            </label>
          </div>

          <div class="section border-top mt-3">
            <label class="po-label"
              >{{ $t("pos.total") }} {{ $t("pos.amount") }}:</label
            >
            <label class="po-amount total">
              <div v-html="$utils.formatMoney(total, currency)" />
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import MultiSelect from "vue-multiselect";
import POItem from "./Item";
import postub from "../../stub/purchaseOrder";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { validationMixin } from "vuelidate";
import Guid from "guid";
import TaxStub from "../../stub/tax";
import Tax from "./POTax";
const {
  required,
  between,
  maxLength,
  numeric
} = require("vuelidate/lib/validators");

export default {
  components: {
    POItem,
    MultiSelect,
    Tax,
    draggable
  },
  mixins: [validationMixin],
  data() {
    return {
      newPurchaseOrder: {
        purchase_order_date: null,
        expiry_date: null,
        purchase_order_number: null,
        supplier_id: null,
        purchase_order_template_id: 1,
        sub_total: null,
        total: null,
        tax: null,
        notes: null,
        discount_type: "fixed",
        discount_val: 0,
        reference_number: null,
        supplier_bank_name: null,
        buyer_bank_name: null,
        discount: 0,
        items: [
          {
            ...postub,
            id: Guid.raw(),
            taxes: [{ ...TaxStub, id: Guid.raw() }]
          }
        ],
        taxes: []
      },
      customers: [],
      itemList: [],
      purchaseOrderTemplates: [],
      selectedCurrency: "",
      taxPerItem: null,
      discountPerItem: null,
      initLoading: false,
      isLoading: false,
      maxDiscount: 0,
      purchaseOrderPrefix: null,
      purchaseOrderNumAttribute: null
    };
  },
  validations() {
    return {
      newPurchaseOrder: {
        purchase_order_date: {
          required
        },
        expiry_date: {
          required
        },
        discount_val: {
          between: between(0, this.subtotal)
        },
        notes: {
          maxLength: maxLength(255)
        },
        reference_number: {
          maxLength: maxLength(255)
        },
        supplier_bank_name: {
          required
        },
        buyer_bank_name: {
          required
        }
      },
      selectedSupplier: {
        required
      }
      // purchaseOrderNumAttribute: {
      //   required,
      //   numeric
      // }
    };
  },
  computed: {
    ...mapGetters("general", ["itemDiscount"]),
    ...mapGetters("currency", ["defaultCurrency"]),

    ...mapGetters("po", ["getTemplateId", "selectedSupplier"]),
    currency() {
      return this.selectedCurrency;
    },
    subtotalWithDiscount() {
      return this.subtotal - this.newPurchaseOrder.discount_val;
    },
    total() {
      if (this.newPurchaseOrder.items) {
        return this.newPurchaseOrder.items.reduce(function(a, b) {
          return a + b["total"];
        }, 0);
      }
    },
    subtotal() {
      if (this.newPurchaseOrder.items) {
        return this.newPurchaseOrder.items.reduce(function(a, b) {
          return a + b["total"];
        }, 0);
      }
    },
    discount: {
      get: function() {
        return this.newPurchaseOrder.discount;
      },
      set: function(newValue) {
        if (this.newPurchaseOrder.discount_type === "percentage") {
          this.newPurchaseOrder.discount_val = (this.subtotal * newValue) / 100;
        } else {
          this.newPurchaseOrder.discount_val = newValue * 100;
        }

        this.newPurchaseOrder.discount = newValue;
      }
    },
    totalSimpleTax() {
      return window._.sumBy(this.newPurchaseOrder.taxes, function(tax) {
        if (!tax.compound_tax) {
          return tax.amount;
        }

        return 0;
      });
    },

    totalCompoundTax() {
      return window._.sumBy(this.newPurchaseOrder.taxes, function(tax) {
        if (tax.compound_tax) {
          return tax.amount;
        }

        return 0;
      });
    },
    totalTax() {
      if (this.taxPerItem === "NO" || this.taxPerItem === null) {
        return this.totalSimpleTax + this.totalCompoundTax;
      }

      return window._.sumBy(this.newPurchaseOrder.items, function(tax) {
        return tax.tax;
      });
    },
    allTaxes() {
      let taxes = [];

      this.newPurchaseOrder.items.forEach(item => {
        item.taxes.forEach(tax => {
          let found = taxes.find(_tax => {
            return _tax.tax_type_id === tax.tax_type_id;
          });

          if (found) {
            found.amount += tax.amount;
          } else if (tax.tax_type_id) {
            taxes.push({
              tax_type_id: tax.tax_type_id,
              amount: tax.amount,
              percent: tax.percent,
              name: tax.name
            });
          }
        });
      });

      return taxes;
    }
  },
  watch: {
    selectedSupplier(newVal) {
      if (newVal && newVal.currency) {
        this.selectedCurrency = newVal.currency;
      } else {
        this.selectedCurrency = this.defaultCurrency;
        this.emptyItemArray();
        this.addItem();
      }
      if (newVal && newVal.company && newVal.company.id) {
        this.fetchInitialItems();
      }
    },
    subtotal(newValue) {
      if (this.newPurchaseOrder.discount_type === "percentage") {
        this.newPurchaseOrder.discount_val =
          (this.newPurchaseOrder.discount * newValue) / 100;
      }
    }
  },
  created() {
    this.loadData();
    this.resetSelectedSupplier();
    // window.hub.$on('newTax', this.onSelectTax)
  },
  methods: {
    ...mapActions("modal", ["openModal"]),
    ...mapActions("po", [
      "addPO",
      "fetchCreatePO",
      "fetchPO",
      "resetSelectedSupplier",
      "selectSupplier",
      "updatePO"
    ]),
    ...mapActions("item", ["fetchItems", "emptyItems"]),
    selectFixed() {
      if (this.newPurchaseOrder.discount_type === "fixed") {
        return;
      }

      this.newPurchaseOrder.discount_val = this.newPurchaseOrder.discount * 100;
      this.newPurchaseOrder.discount_type = "fixed";
    },
    selectPercentage() {
      if (this.newPurchaseOrder.discount_type === "percentage") {
        return;
      }

      this.newPurchaseOrder.discount_val =
        (this.subtotal * this.newPurchaseOrder.discount) / 100;

      this.newPurchaseOrder.discount_type = "percentage";
    },
    updateTax(data) {
      Object.assign(this.newPurchaseOrder.taxes[data.index], { ...data.item });
    },
    async fetchInitialItems() {
      let res = await this.fetchItems({
        orderByField: "",
        orderBy: "",
        pagination: "no",
        companyId: this.selectedSupplier.company.id
      });
    },
    async loadData() {
      if (this.$route.name === "purchase-orders.edit") {
        this.initLoading = true;
        let response = await this.fetchPO(this.$route.params.id);

        if (response.data) {
          this.selectSupplier(response.data.purchaseOrder.supplier_id);
          this.newPurchaseOrder = response.data.purchaseOrder;
          this.newPurchaseOrder.purchase_order_date = moment(
            response.data.purchaseOrder.purchase_order_date,
            "YYYY-MM-DD"
          ).toString();
          this.newPurchaseOrder.expiry_date = moment(
            response.data.purchaseOrder.expiry_date,
            "YYYY-MM-DD"
          ).toString();
          this.discountPerItem = response.data.discount_per_item;
          this.taxPerItem = response.data.tax_per_item;
          this.selectedCurrency = this.defaultCurrency;
          this.purchaseOrderTemplates = response.data.purchaseOrderTemplates;
          this.purchaseOrderPrefix = response.data.purchase_order_prefix;
          this.purchaseOrderNumAttribute =
            response.data.nextPurchaseOrderNumber;
        }
        this.initLoading = false;
        return;
      }

      this.initLoading = true;
      let response = await this.fetchCreatePO();
      if (response.data) {
        this.discountPerItem = response.data.discount_per_item;
        this.taxPerItem = response.data.tax_per_item;
        this.selectedCurrency = this.defaultCurrency;
        this.purchaseOrderTemplates = response.data.purchaseOrderTemplates;
        let today = new Date();
        this.newPurchaseOrder.purchase_order_date = moment(today).toString();
        this.newPurchaseOrder.expiry_date = moment(today)
          .add(7, "days")
          .toString();
        this.itemList = response.data.items;
        this.purchaseOrderPrefix = response.data.purchase_order_prefix;
        this.purchaseOrderNumAttribute =
          response.data.nextPurchaseOrderNumberAttribute;
      }
      this.initLoading = false;
    },
    removeSupplier() {
      this.resetSelectedSupplier();
      this.emptyItems();
    },
    editCustomer() {
      this.openModal({
        title: this.$t("customers.edit_customer"),
        componentName: "CustomerModal",
        id: this.selectedSupplier.id,
        data: this.selectedSupplier
      });
    },
    openTemplateModal() {
      this.openModal({
        title: this.$t("general.choose_template"),
        componentName: "PurchaseOrderTemplate",
        data: this.purchaseOrderTemplates
      });
    },
    addItem() {
      this.newPurchaseOrder.items.push({
        ...postub,
        id: Guid.raw(),
        taxes: [{ ...TaxStub, id: Guid.raw() }]
      });
    },
    removeItem(index) {
      this.newPurchaseOrder.items.splice(index, 1);
    },
    emptyItemArray() {
      this.newPurchaseOrder.items.splice(0, this.newPurchaseOrder.items.length);
    },
    updateItem(data) {
      Object.assign(this.newPurchaseOrder.items[data.index], { ...data.item });
    },
    POAttchements() {
      let redirectPOAttachment;
      this.submitPurchaseOrderData((redirectPOAttachment = true));
    },
    submitPurchaseOrderData(redirectPOAttachment = false) {
      console.log("this.checkValid() ", this.checkValid());
      if (!this.checkValid()) {
        return false;
      }

      this.isLoading = true;
      this.newPurchaseOrder.purchase_order_number =
        this.purchaseOrderPrefix + "-" + this.purchaseOrderNumAttribute;

      let data = {
        ...this.newPurchaseOrder,
        purchase_order_date: moment(
          this.newPurchaseOrder.purchase_order_date
        ).format("DD/MM/YYYY"),
        expiry_date: moment(this.newPurchaseOrder.expiry_date).format(
          "DD/MM/YYYY"
        ),
        supplier_bank_name: this.newPurchaseOrder.supplier_bank_name,
        buyer_bank_name: this.newPurchaseOrder.buyer_bank_name,
        sub_total: this.subtotal,
        total: this.total,
        tax: this.totalTax,
        supplier_id: null,
        purchase_order_template_id: this.getTemplateId
      };
      if (this.selectedSupplier != null) {
        data.supplier_id = this.selectedSupplier.id;
      }

      if (this.$route.name === "purchase-orders.edit") {
        this.submitUpdate(data, redirectPOAttachment);
        return;
      }
      this.submitSave(data, redirectPOAttachment);
    },

    submitSave(data, redirectPOAttachment = false) {
      console.log("data ", data);
      this.addPO(data)
        .then(res => {
          if (res.data.result === "success") {
            window.toastr["success"](this.$t("pos.created_message"));
            if (redirectPOAttachment === true) {
              this.$router.push(
                `/anchor/purchase-orders/${
                  res.data.purchaseOrder.id
                }/attachment`
              );
            } else {
              this.$router.push("/anchor/purchase-orders");
            }
          } else if (res.data.result === "error") {
            window.toastr["error"](res.data.message);
          }

          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
          if (err.response.data.errors.purchase_order_number) {
            window.toastr["error"](
              err.response.data.errors.purchase_order_number
            );
            return true;
          } else if (err.response.data.errors.reference_number) {
            window.toastr["error"](err.response.data.errors.reference_number);
            return true;
          }
          window.toastr["error"](err.response.data.message);
        });
    },
    submitUpdate(data, redirectPOAttachment = false) {
      this.updatePO(data)
        .then(res => {
          if (res.data.result === "success") {
            window.toastr["success"](this.$t("pos.updated_message"));
            if (redirectPOAttachment === true) {
              this.$router.push(
                `/anchor/purchase-orders/${
                  res.data.purchaseOrder.id
                }/attachment`
              );
            } else {
              this.$router.push("/anchor/purchase-orders");
            }
          } else if (res.data.result === "error") {
            window.toastr["error"](res.data.message);
          }

          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
          if (err.response.data.errors.purchase_order_number) {
            window.toastr["error"](
              err.response.data.errors.purchase_order_number
            );
            return true;
          }
          window.toastr["error"](err.response.data.message);
        });
    },
    checkItemsData(index, isValid) {
      console.log(isValid);
      this.newPurchaseOrder.items[index].valid = isValid;
    },
    onSelectTax(selectedTax) {
      let amount = 0;

      if (selectedTax.compound_tax && this.subtotalWithDiscount) {
        amount =
          ((this.subtotalWithDiscount + this.totalSimpleTax) *
            selectedTax.percent) /
          100;
      } else if (this.subtotalWithDiscount && selectedTax.percent) {
        amount = (this.subtotalWithDiscount * selectedTax.percent) / 100;
      }

      this.newPurchaseOrder.taxes.push({
        ...TaxStub,
        id: Guid.raw(),
        name: selectedTax.name,
        percent: selectedTax.percent,
        compound_tax: selectedTax.compound_tax,
        tax_type_id: selectedTax.id,
        amount
      });

      this.$refs.taxModal.close();
    },
    removePurchaseOrderTax(index) {
      this.newPurchaseOrder.taxes.splice(index, 1);
    },
    checkValid() {
      this.$v.newPurchaseOrder.$touch();
      this.$v.selectedSupplier.$touch();
      window.hub.$emit("checkItems");
      let isValid = true;
      this.newPurchaseOrder.items.forEach(item => {
        console.log(item.valid);
        if (!item.valid) {
          isValid = false;
        }
      });
      if (
        !this.$v.selectedSupplier.$invalid &&
        this.$v.newPurchaseOrder.$invalid === false &&
        isValid === true
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>
